var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBht(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9394,
    height: 33.9394,
    transform: "translate(0.237549)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0627 7.17822V13.3018H16.1415V7.17822H18.052V21.8135H16.1415V14.9557H9.0627V21.8207H7.17358V7.17822H9.0627Z",
    strokeWidth: 0.356437,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7751 27.1814C20.8037 26.768 20.825 26.1478 20.825 25.606V18.242H21.9229V22.0701H21.9514C22.3435 21.3929 23.0492 20.9509 24.033 20.9509C25.5443 20.9509 26.6136 22.2127 26.5993 24.0591C26.5993 26.2405 25.2235 27.324 23.869 27.324C22.9851 27.324 22.2793 26.9818 21.8302 26.1763H21.7946L21.7447 27.1814H20.7894H20.7751ZM21.9229 24.7363C21.9229 24.8717 21.9514 25.0143 21.9728 25.1426C22.1866 25.9125 22.8282 26.4401 23.6338 26.4401C24.7886 26.4401 25.4872 25.4919 25.4872 24.0947C25.4872 22.8757 24.8599 21.8278 23.6765 21.8278C22.9209 21.8278 22.2152 22.341 21.987 23.1894C21.9585 23.3177 21.9229 23.4674 21.9229 23.6456V24.7434V24.7363Z",
    strokeWidth: 0.356437,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7751,
    height: 20.4951,
    fill: "white",
    transform: "translate(6.99536 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBht);
export default __webpack_public_path__ + "static/media/bht.0e3e755ad06a682c6cbeabbf672b70a7.svg";
export { ForwardRef as ReactComponent };